module.exports = __webpack_public_path__ + "assets/icons-sprite.a266bc95.svg";